// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.ids-calendar-event-group:not([color]):not(.calendar-event-continue):not(.calendar-event-ends) {
  border-inline-start-width: 4px;
  border-inline-start-color: var(--ids-calendar-event-color-border-default);
}
.ids-calendar-event-group:not([color]) {
  background-color: var(--ids-calendar-event-color-background);
}

.ids-calendar-event-group {
  position: absolute;
  box-sizing: border-box;
  width: 100%;
  z-index: var(--ids-z-index-10);
  background: var(--ids-calendar-event-color-background);
  border: 1px solid transparent;
  border-radius: var(--ids-border-radius-xs);
  color: var(--ids-calendar-event-color-text);
  overflow: hidden;
  text-decoration: none;
}
.ids-calendar-event-group .header {
  display: flex;
  align-items: center;
  width: 100%;
  gap: 4px;
}
.ids-calendar-event-group .header ids-tag {
  margin-inline-start: auto;
}
.ids-calendar-event-group .calendar-event-content {
  box-sizing: border-box;
  height: 100%;
  width: 100%;
  padding: var(--ids-space-3xs) 5px;
}
.ids-calendar-event-group .calendar-event-content ids-text {
  display: block;
  width: 100%;
  height: 100%;
}
.ids-calendar-event-group .calendar-event-icon {
  vertical-align: bottom;
  position: relative;
  margin-inline-end: 1px;
  margin-inline-start: -1px;
}
.ids-calendar-event-group .calendar-event-icon[icon=success-alert] {
  color: var(--ids-calendar-event-color-icon-success);
}
.ids-calendar-event-group .calendar-event-icon[icon=alert-alert] {
  color: var(--ids-calendar-event-color-icon-alert);
}
.ids-calendar-event-group .calendar-event-icon[icon=clock] {
  color: var(--ids-calendar-event-color-icon-clock);
}
.ids-calendar-event-group .calendar-event-icon[icon=pending] {
  color: var(--ids-calendar-event-color-icon-pending);
}
.ids-calendar-event-group .calendar-event-title {
  line-height: 14px;
}
.ids-calendar-event-group .calendar-event-title::part(text) {
  text-transform: initial;
}
.ids-calendar-event-group.is-cutoff {
  border-radius: 3px 3px 0 0;
}
.ids-calendar-event-group.is-ellipsis .calendar-event-content {
  white-space: nowrap;
}
.ids-calendar-event-group.reduced-padding .calendar-event-content {
  padding: 0 5px;
}
.ids-calendar-event-group.reduced-padding .calendar-event-title {
  position: relative;
  top: -1.6px;
}
.ids-calendar-event-group[color=primary]:not(.calendar-event-continue):not(.calendar-event-ends) {
  border-inline-start-width: 4px;
  border-inline-start-color: var(--ids-calendar-event-color-border-accent-primary);
}
.ids-calendar-event-group[color=primary] {
  background-color: var(--ids-calendar-event-color-background-accent-primary);
  color: var(--ids-calendar-event-color-forecolor-light);
}
.ids-calendar-event-group[color=blue]:not(.calendar-event-continue):not(.calendar-event-ends) {
  border-inline-start-width: 4px;
  border-inline-start-color: var(--ids-calendar-event-color-border-accent-blue);
}
.ids-calendar-event-group[color=blue] {
  background-color: var(--ids-calendar-event-color-background-accent-blue);
}
.ids-calendar-event-group[color=blue] ids-tag {
  --ids-tag-color-background-default: var(--ids-calendar-event-color-background-accent-blue);
  --ids-tag-color-text-default: var(--ids-calendar-event-color-forecolor-light);
}
.ids-calendar-event-group[color=orange]:not(.calendar-event-continue):not(.calendar-event-ends) {
  border-inline-start-width: 4px;
  border-inline-start-color: var(--ids-calendar-event-color-border-accent-orange);
}
.ids-calendar-event-group[color=orange] {
  background-color: var(--ids-calendar-event-color-background-accent-orange);
}
.ids-calendar-event-group[color=orange] ids-tag {
  --ids-tag-color-background-default: var(--ids-calendar-event-color-background-accent-orange);
  --ids-tag-color-text-default: var(--ids-calendar-event-color-forecolor-light);
}
.ids-calendar-event-group[color=neutral]:not(.calendar-event-continue):not(.calendar-event-ends) {
  border-inline-start-width: 4px;
  border-inline-start-color: var(--ids-calendar-event-color-border-accent-neutral);
}
.ids-calendar-event-group[color=neutral] {
  background-color: var(--ids-calendar-event-color-background-accent-neutral);
}
.ids-calendar-event-group[color=neutral] ids-tag {
  --ids-tag-color-background-default: var(--ids-calendar-event-color-background-accent-neutral);
  --ids-tag-color-text-default: var(--ids-calendar-event-color-forecolor-light);
}
.ids-calendar-event-group[color=purple]:not(.calendar-event-continue):not(.calendar-event-ends) {
  border-inline-start-width: 4px;
  border-inline-start-color: var(--ids-calendar-event-color-border-accent-purple);
}
.ids-calendar-event-group[color=purple] {
  background-color: var(--ids-calendar-event-color-background-accent-purple);
}
.ids-calendar-event-group[color=purple] ids-tag {
  --ids-tag-color-background-default: var(--ids-calendar-event-color-background-accent-purple);
  --ids-tag-color-text-default: var(--ids-calendar-event-color-forecolor-light);
}
.ids-calendar-event-group[color=green]:not(.calendar-event-continue):not(.calendar-event-ends) {
  border-inline-start-width: 4px;
  border-inline-start-color: var(--ids-calendar-event-color-border-accent-green);
}
.ids-calendar-event-group[color=green] {
  background-color: var(--ids-calendar-event-color-background-accent-green);
}
.ids-calendar-event-group[color=green] ids-tag {
  --ids-tag-color-background-default: var(--ids-calendar-event-color-border-accent-green);
  --ids-tag-color-text-default: var(--ids-calendar-event-color-forecolor-light);
}
.ids-calendar-event-group[color=red]:not(.calendar-event-continue):not(.calendar-event-ends) {
  border-inline-start-width: 4px;
  border-inline-start-color: var(--ids-calendar-event-color-border-accent-red);
}
.ids-calendar-event-group[color=red] {
  background-color: var(--ids-calendar-event-color-background-accent-red);
}
.ids-calendar-event-group[color=red] ids-tag {
  --ids-tag-color-background-default: var(--ids-calendar-event-color-background-accent-red);
  --ids-tag-color-text-default: var(--ids-calendar-event-color-forecolor-light);
}
.ids-calendar-event-group[color=teal]:not(.calendar-event-continue):not(.calendar-event-ends) {
  border-inline-start-width: 4px;
  border-inline-start-color: var(--ids-calendar-event-color-border-accent-turqoise);
}
.ids-calendar-event-group[color=teal] {
  background-color: var(--ids-calendar-event-color-background-accent-turqoise);
}
.ids-calendar-event-group[color=teal] ids-tag {
  --ids-tag-color-background-default: var(--ids-calendar-event-color-background-accent-turqoise);
  --ids-tag-color-text-default: var(--ids-calendar-event-color-forecolor-light);
}

.ids-calendar-event-group.all-day {
  top: 1px;
}
.ids-calendar-event-group.all-day.calendar-event-start, .ids-calendar-event-group.all-day.calendar-event-continue, .ids-calendar-event-group.all-day.calendar-event-ends {
  border-radius: 0;
}
.ids-calendar-event-group.all-day.calendar-event-start {
  border-start-start-radius: 3px;
  border-end-start-radius: 3px;
}
.ids-calendar-event-group.all-day.calendar-event-continue {
  width: calc(100% + 2px);
  margin-inline-start: -1px;
}
.ids-calendar-event-group.all-day.calendar-event-ends {
  border-end-end-radius: 3px;
  border-start-end-radius: 3px;
}
.ids-calendar-event-group.all-day.calendar-event-continue ids-icon, .ids-calendar-event-group.all-day.calendar-event-ends ids-icon {
  visibility: hidden;
}
.ids-calendar-event-group.all-day.calendar-event-continue .calendar-event-title, .ids-calendar-event-group.all-day.calendar-event-ends .calendar-event-title {
  color: var(--ids-color-transparent);
}

.ids-calendar-event-group.is-month-view {
  position: absolute;
  display: block;
}
.ids-calendar-event-group.is-month-view:not(.all-day) {
  width: calc(100% - 10px);
  margin: 0 5px;
}
.ids-calendar-event-group.is-month-view .calendar-event-group-content {
  display: flex;
  align-items: center;
  gap: 4px;
  padding: 2px 5px;
  max-height: 22px;
  height: 100%;
}`, "",{"version":3,"sources":["webpack://./src/components/ids-calendar/ids-calendar-event-group.scss"],"names":[],"mappings":"AACE;EACE,8BAAA;EACA,yEAM2B;AAN/B;AAKA;EAGE,4DAAA;AALF;;AAQA;EACE,kBAAA;EACA,sBAAA;EACA,WAAA;EACA,8BAAA;EACA,sDAAA;EACA,6BAAA;EACA,0CAAA;EACA,2CAAA;EACA,gBAAA;EACA,qBAAA;AALF;AAOE;EACE,aAAA;EACA,mBAAA;EACA,WAAA;EACA,QAAA;AALJ;AAOI;EACE,yBAAA;AALN;AASE;EACE,sBAAA;EACA,YAAA;EACA,WAAA;EACA,iCAAA;AAPJ;AASI;EACE,cAAA;EACA,WAAA;EACA,YAAA;AAPN;AAWE;EACE,sBAAA;EACA,kBAAA;EACA,sBAAA;EACA,yBAAA;AATJ;AAWI;EACE,mDAAA;AATN;AAYI;EACE,iDAAA;AAVN;AAaI;EACE,iDAAA;AAXN;AAcI;EACE,mDAAA;AAZN;AAgBE;EACE,iBAAA;AAdJ;AAgBI;EACE,uBAAA;AAdN;AAmBE;EACE,0BAAA;AAjBJ;AAqBI;EACE,mBAAA;AAnBN;AAwBI;EACE,cAAA;AAtBN;AAyBI;EACE,kBAAA;EACA,WAAA;AAvBN;AA3EE;EACE,8BAAA;EACA,gFAsG6B;AAzBjC;AAwBE;EAGE,2EAAA;EACA,sDAAA;AAxBJ;AAnFE;EACE,8BAAA;EACA,6EA6G6B;AAxBjC;AAuBE;EAGE,wEAAA;AAvBJ;AAyBI;EACE,0FAAA;EACA,6EAAA;AAvBN;AA9FE;EACE,8BAAA;EACA,+EAwH6B;AAxBjC;AAuBE;EAGE,0EAAA;AAvBJ;AAyBI;EACE,4FAAA;EACA,6EAAA;AAvBN;AAzGE;EACE,8BAAA;EACA,gFAmI6B;AAxBjC;AAuBE;EAGE,2EAAA;AAvBJ;AAyBI;EACE,6FAAA;EACA,6EAAA;AAvBN;AApHE;EACE,8BAAA;EACA,+EA8I6B;AAxBjC;AAuBE;EAGE,0EAAA;AAvBJ;AAyBI;EACE,4FAAA;EACA,6EAAA;AAvBN;AA/HE;EACE,8BAAA;EACA,8EAyJ6B;AAxBjC;AAuBE;EAGE,yEAAA;AAvBJ;AAyBI;EACE,uFAAA;EACA,6EAAA;AAvBN;AA1IE;EACE,8BAAA;EACA,4EAoK6B;AAxBjC;AAuBE;EAGE,uEAAA;AAvBJ;AAyBI;EACE,yFAAA;EACA,6EAAA;AAvBN;AArJE;EACE,8BAAA;EACA,iFA+K6B;AAxBjC;AAuBE;EAGE,4EAAA;AAvBJ;AAyBI;EACE,8FAAA;EACA,6EAAA;AAvBN;;AA6BA;EACE,QAAA;AA1BF;AA4BE;EAGE,gBAAA;AA5BJ;AAgCE;EACE,8BAAA;EACA,4BAAA;AA9BJ;AAiCE;EACE,uBAAA;EACA,yBAAA;AA/BJ;AAmCE;EACE,0BAAA;EACA,4BAAA;AAjCJ;AAsCI;EACE,kBAAA;AApCN;AAuCI;EACE,mCAAA;AArCN;;AA2CA;EAGE,kBAAA;EACA,cAAA;AA1CF;AA4CE;EACE,wBAAA;EACA,aAAA;AA1CJ;AA6CE;EACE,aAAA;EACA,mBAAA;EACA,QAAA;EACA,gBAAA;EACA,gBAAA;EACA,YAAA;AA3CJ","sourcesContent":["@mixin event-border-accent($color) {\n  &:not(.calendar-event-continue):not(.calendar-event-ends) {\n    border-inline-start-width: 4px;\n    border-inline-start-color: $color;\n  }\n}\n\n// Calendar Event Type Themes\n.ids-calendar-event-group:not([color]) {\n  @include event-border-accent(var(--ids-calendar-event-color-border-default));\n\n  background-color: var(--ids-calendar-event-color-background);\n}\n\n.ids-calendar-event-group {\n  position: absolute;\n  box-sizing: border-box;\n  width: 100%;\n  z-index: var(--ids-z-index-10);\n  background: var(--ids-calendar-event-color-background);\n  border: 1px solid transparent;\n  border-radius: var(--ids-border-radius-xs);\n  color: var(--ids-calendar-event-color-text);\n  overflow: hidden;\n  text-decoration: none;\n\n  .header {\n    display: flex;\n    align-items: center;\n    width: 100%;\n    gap: 4px;\n\n    ids-tag {\n      margin-inline-start: auto;\n    }\n  }\n\n  .calendar-event-content {\n    box-sizing: border-box;\n    height: 100%;\n    width: 100%;\n    padding: var(--ids-space-3xs) 5px;\n\n    ids-text {\n      display: block;\n      width: 100%;\n      height: 100%;\n    }\n  }\n\n  .calendar-event-icon {\n    vertical-align: bottom;\n    position: relative;\n    margin-inline-end: 1px;\n    margin-inline-start: -1px;\n\n    &[icon='success-alert'] {\n      color: var(--ids-calendar-event-color-icon-success);\n    }\n\n    &[icon='alert-alert'] {\n      color: var(--ids-calendar-event-color-icon-alert);\n    }\n\n    &[icon='clock'] {\n      color: var(--ids-calendar-event-color-icon-clock);\n    }\n\n    &[icon='pending'] {\n      color: var(--ids-calendar-event-color-icon-pending);\n    }\n  }\n\n  .calendar-event-title {\n    line-height: 14px;\n\n    &::part(text) {\n      text-transform: initial;\n    }\n  }\n\n  // Styles for intraday events\n  &.is-cutoff {\n    border-radius: 3px 3px 0 0;\n  }\n\n  &.is-ellipsis {\n    .calendar-event-content {\n      white-space: nowrap;\n    }\n  }\n\n  &.reduced-padding {\n    .calendar-event-content {\n      padding: 0 5px;\n    }\n\n    .calendar-event-title {\n      position: relative;\n      top: -1.6px;\n    }\n  }\n\n\n  &[color='primary'] {\n    @include event-border-accent(var(--ids-calendar-event-color-border-accent-primary));\n\n    background-color: var(--ids-calendar-event-color-background-accent-primary);\n    color: var(--ids-calendar-event-color-forecolor-light);\n  }\n\n  &[color='blue'] {\n    @include event-border-accent(var(--ids-calendar-event-color-border-accent-blue));\n\n    background-color: var(--ids-calendar-event-color-background-accent-blue);\n\n    ids-tag {\n      --ids-tag-color-background-default: var(--ids-calendar-event-color-background-accent-blue);\n      --ids-tag-color-text-default: var(--ids-calendar-event-color-forecolor-light);\n    }\n  }\n\n  &[color='orange'] {\n    @include event-border-accent(var(--ids-calendar-event-color-border-accent-orange));\n\n    background-color: var(--ids-calendar-event-color-background-accent-orange);\n\n    ids-tag {\n      --ids-tag-color-background-default: var(--ids-calendar-event-color-background-accent-orange);\n      --ids-tag-color-text-default: var(--ids-calendar-event-color-forecolor-light);\n    }\n  }\n\n  &[color='neutral'] {\n    @include event-border-accent(var(--ids-calendar-event-color-border-accent-neutral));\n\n    background-color: var(--ids-calendar-event-color-background-accent-neutral);\n\n    ids-tag {\n      --ids-tag-color-background-default: var(--ids-calendar-event-color-background-accent-neutral);\n      --ids-tag-color-text-default: var(--ids-calendar-event-color-forecolor-light);\n    }\n  }\n\n  &[color='purple'] {\n    @include event-border-accent(var(--ids-calendar-event-color-border-accent-purple));\n\n    background-color: var(--ids-calendar-event-color-background-accent-purple);\n\n    ids-tag {\n      --ids-tag-color-background-default: var(--ids-calendar-event-color-background-accent-purple);\n      --ids-tag-color-text-default: var(--ids-calendar-event-color-forecolor-light);\n    }\n  }\n\n  &[color='green'] {\n    @include event-border-accent(var(--ids-calendar-event-color-border-accent-green));\n\n    background-color: var(--ids-calendar-event-color-background-accent-green);\n\n    ids-tag {\n      --ids-tag-color-background-default: var(--ids-calendar-event-color-border-accent-green);\n      --ids-tag-color-text-default: var(--ids-calendar-event-color-forecolor-light);\n    }\n  }\n\n  &[color='red'] {\n    @include event-border-accent(var(--ids-calendar-event-color-border-accent-red));\n\n    background-color: var(--ids-calendar-event-color-background-accent-red);\n\n    ids-tag {\n      --ids-tag-color-background-default: var(--ids-calendar-event-color-background-accent-red);\n      --ids-tag-color-text-default: var(--ids-calendar-event-color-forecolor-light);\n    }\n  }\n\n  &[color='teal'] {\n    @include event-border-accent(var(--ids-calendar-event-color-border-accent-turqoise));\n\n    background-color: var(--ids-calendar-event-color-background-accent-turqoise);\n\n    ids-tag {\n      --ids-tag-color-background-default: var(--ids-calendar-event-color-background-accent-turqoise);\n      --ids-tag-color-text-default: var(--ids-calendar-event-color-forecolor-light);\n    }\n  }\n}\n\n// All day event styles\n.ids-calendar-event-group.all-day {\n  top: 1px;\n\n  &.calendar-event-start,\n  &.calendar-event-continue,\n  &.calendar-event-ends {\n    border-radius: 0;\n  }\n\n  // first of multi day\n  &.calendar-event-start {\n    border-start-start-radius: 3px;\n    border-end-start-radius: 3px;\n  }\n\n  &.calendar-event-continue {\n    width: calc(100% + 2px);\n    margin-inline-start: -1px;\n  }\n\n  // end of multiday\n  &.calendar-event-ends {\n    border-end-end-radius: 3px;\n    border-start-end-radius: 3px;\n  }\n\n  &.calendar-event-continue,\n  &.calendar-event-ends {\n    ids-icon {\n      visibility: hidden;\n    }\n\n    .calendar-event-title {\n      color: var(--ids-color-transparent);\n    }\n  }\n}\n\n// Month View Styles\n.ids-calendar-event-group.is-month-view {\n  $month-margin: 5px;\n\n  position: absolute;\n  display: block;\n\n  &:not(.all-day) {\n    width: calc(100% - ($month-margin * 2));\n    margin: 0 $month-margin;\n  }\n\n  .calendar-event-group-content {\n    display: flex;\n    align-items: center;\n    gap: 4px;\n    padding: 2px 5px;\n    max-height: 22px;\n    height: 100%;\n  }\n}\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
